import { createFileRoute, redirect } from '@tanstack/react-router';
import { isPersonAdmin } from 'helpers/query';
import { z } from 'zod';
import { zBooleanFiltersArray, zFiltersArray } from 'helpers/router';
import {
  // zFunction,
  // zIndustry,
  zDeclinedStatusFilter,
  zIntroductionStatusFilter,
  zRecommendationStatusFilter,
  zSortDirection,
  zTeamCandidatesSortColumn,
  zCandidatePipelineStatus,
} from 'client/zod.gen';

export const Schema = z.preprocess(
  (val) => {
    // If the value is undefined, null, or an empty object,
    // return undefined to go straight to the default value.
    if (!val) return undefined;
    if (typeof val === 'object' && val && Object.keys(val).length === 0) {
      return undefined;
    }
    return val;
  },
  z
    .object({
      // possible values are all the keys of PipelineCandidatesFilters
      // filtersDialog: z
      //   .enum([
      //     'as',
      //     'industry_expertise',
      //     'team_status',
      //     'warm',
      //     'tier',
      //     'underrepresented',
      //   ])
      //   .optional()
      //   .catch(undefined),
      advisor_id: zFiltersArray(),
      declined_status: zFiltersArray(zDeclinedStatusFilter),
      introduction_status: zFiltersArray(zIntroductionStatusFilter),
      is_accepting_intros: zBooleanFiltersArray(),
      recommendation_status: zFiltersArray(zRecommendationStatusFilter),
      underrepresented: zBooleanFiltersArray(),
      warm: zBooleanFiltersArray(),
      pipeline_status: zFiltersArray(zCandidatePipelineStatus)
        .catch([
          'suggested',
          'ready_for_review',
          'approved',
          'denied',
          'published',
          'scheduled',
          'saved',
        ])
        .default([
          'suggested',
          'ready_for_review',
          'approved',
          'denied',
          'published',
          'scheduled',
          'saved',
        ]),
      // function_expertise: zFiltersArray(zFunction),
      // industry_expertise: zFiltersArray(zIndustry),
      order: zSortDirection.optional().catch('desc').default('desc'),
      sort: zTeamCandidatesSortColumn.optional(),
      // .catch('created')
      // .default('created'),
    })
    .optional()
    // If the search param object is undefined, zod will go straight here.
    .default({
      order: 'desc',
      pipeline_status: [
        'suggested',
        'ready_for_review',
        'approved',
        'denied',
        'published',
        'scheduled',
        'saved',
      ],
      // sort: 'created',
    })
    // If an uncaught error occurs during parsing, zod will go here.
    .catch({
      order: 'desc',
      pipeline_status: [
        'suggested',
        'ready_for_review',
        'approved',
        'denied',
        'published',
        'scheduled',
        'saved',
      ],
      // sort: 'created',
    }),
);

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/',
)({
  beforeLoad: async ({ context, params, search }) => {
    const { user } = context;
    const isAdmin = isPersonAdmin(user);
    if (isAdmin) {
      if (!search.pipeline_status) {
        throw redirect({
          replace: true,
          search: {
            pipeline_status: [
              'suggested',
              'ready_for_review',
              'approved',
              'denied',
              'published',
              'scheduled',
              'saved',
            ],
          },
        });
      }
      return;
    }

    throw redirect({
      to: '/teams/$teamId/pipelines/$pipelineId/recommendations',
      params,
    });
  },
  loaderDeps: ({ search }) => ({
    pipeline_status: search.pipeline_status,
    order: search.order,
    sort: search.sort,
  }),
  validateSearch: Schema,
});
